import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    tableBody: {
      '& #pagination-last-page': {
        display: 'none',
      },
      '& #pagination-first-page': {
        display: 'none',
      },
    },
  };
});

export { useStyles };
